/* eslint-disable */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import PrivateRoute from './routing/PrivateRoute';
import { overrideConsole } from './hooks/loggingErrors';
import HeaderAndFooter from './layouts/HeaderAndFooter/HeaderAndFooter';
import HomePage from './pages/HomePage/HomePage';
// Legal page routes
import LegalPage from './pages/LegalPage/LegalPage';
import OppitionsPage from './pages/LegalPage/TrademarkPages/OppitionsPage';
import RegistrationsTreadPage from './pages/LegalPage/TrademarkPages/RegistrationsTreadPage';
import ComplaintsPage from './pages/LegalPage/DoaminPages/ComplaintsPage';
import RegistrationsPage from './pages/LegalPage/DoaminPages/RegistrationPage';
// Transitions page routes
import TransitionPage from './pages/Transition/TransitionPage';
// Process Excellence routes
import ProcessExcellencePage from './pages/ProcessExcellencePage/ProcessExcellencePage';
//QualityPage
import QualityPage from './pages/QualityPage/QualityPage';
import QualityObservationDetailPage from './pages/QualityPage/QualityObservationDeatilPage/QualityObservationDetailPage';
import MrcDeatiledPage from './pages/QualityPage/MrcDetailedPage/MrcDeatiledPage';
// File upload page routes
import FileUpload from './pages/FileUpload/FileUpload';
import FileUploadCheck from './pages/FileUploadCheck/FileUploadCheck';
import TemplateApprove from './pages/FileUploadCheck/TemplateApprove';
// Admin page routes
import AdminPage from './pages/AdminPage/AdminPage';
// P2P Pages routes
import P2PMainPage from './pages/ProcureToPayPage/P2PMainPage';
import PurchaseAndMDM from './pages/ProcureToPayPage/PurchaseAndMDMPage';
import AccountsPayablePage from './pages/ProcureToPayPage/AccountsPayablePage';
import CRDOPage from './pages/ProcureToPayPage/CRDOPage';
import VMOandContactCenterPage from './pages/ProcureToPayPage/VMOandContactCenterPage';
import VendorPaymentSchemePage from './pages/ProcureToPayPage/VendorPaymentSchemePage';
import JLRP2PMainPage from './pages/ProcureToPayPage/JLRP2PMainPage';
import AgratasP2PMainPage from './pages/ProcureToPayPage/AgratasP2PMainPage';
import MDMPage from './pages/ProcureToPayPage/MDMPage';
// Indirect Tax page routes
import IndirectTaxPage from './pages/IndirectTax/IndirectTaxPage';
import GstrFilingPage from './pages/IndirectTax/GstrFilingPage/GstrFilingPage';
import DepartmentalPage from './pages/IndirectTax/DepartmentalPage/DepartmentalPage';
// RecordToReport Page routes
import RecordToReportPage from './pages/RecordToReportPage/RecordToReportTMLPage/RecordToReportPage';
import RecordToReportJLR from './pages/RecordToReportPage/RecordToReportJLRPage/RecordToReportJLR';
import RecordToReportAgratasPage from './pages/RecordToReportPage/RecordToReportAgratasPage/RecordToReportAgratasPage';
import RecordToReportTMLChildPage from './pages/RecordToReportPage/RecordToReportTMLPage/RecordToReportTMLChildPage';
import RecordToReportJLRChildPage from './pages/RecordToReportPage/RecordToReportJLRPage/RecordToReportJLRChildPage';
import RecordToReportAgratasChildPage from './pages/RecordToReportPage/RecordToReportAgratasPage/RecordToReportAgratasChildPage';
// O2C Page routes
import O2CMainPage from './pages/O2CPage/O2CMainPage';
import O2CSalesPage from './pages/O2CPage/O2CSalesPage';
import O2CDispatchAndBillingPage from './pages/O2CPage/O2CDispatchAndBillingPage';
import O2CAfterSalesPage from './pages/O2CPage/O2CAfterSalesPage';
// H2R Page routes
import HireToRetireMainPage from './pages/HireToRetirePage/HireToRetireMainPage';
import PayrollAndCompliancePage from './pages/HireToRetirePage/PayrollAndCompliancePage';
import TimeOfficeRetrialsPage from './pages/HireToRetirePage/TimeOfficeRetrialsPage';
import BenefitsAdministrationPage from './pages/HireToRetirePage/BenefitsAdministrationPage';
import RecuritmentPage from './pages/HireToRetirePage/RecuritmentPage';
// Finance Page routes
import FinancePage from './pages/Finance/FinancePage';
import RevenueBusinessPage from './pages/Finance/RevenueBusinessPage/RevenueBusinessPage';
import ContractDsoPage from './pages/Finance/ContractDsoPage/ContractDsoPage';
import FinanceCostPage from './pages/Finance/FinanceCostPage/FinanceCostPage';
import MarginTmgslPage from './pages/Finance/MarginTmgslPage/MarginTmgslPage';
import GdcDistPage from './pages/Finance/GdcDistPage/GdcDistPage';
// Direct Tax Pages
import DirectTaxPage from './pages/DirectTaxPage/DirectTaxPage';
import AnnualTaxFilingsPage from './pages/DirectTaxPage/AnnualTaxFilingsPage/AnnualTaxFilingsPage';
import DepartmentalNotice from './pages/DirectTaxPage/DepartmentalNotices/DepartmentalNotice';
import AnnualTaxPage from './pages/DirectTaxPage/TDSPages/AnnualTaxPage';
import TDSReturns from './pages/DirectTaxPage/TDSPages/TDSReturns';
//HSN Report
import HSNDetailReportPageComp from './components/HSNPageComp/HSNDetailReportPageComp';
import HSNGSTRatewiseReport from './components/HSNPageComp/HSNGSTRatewiseReport';

import FileUploadLogs from './pages/FileUploadLogs/FileUploadLogs';

// GL Recon
import GLReconPage from './pages/GLReconPage/GLReconPage';
import GLReconPageDetail from './pages/ProcureToPayPage/GLReconPageDetail';
// GL Retention Page
import GLRetantionPage from './pages/GLRetantionPage/GLRetantionPage';

import PageUnderConstructionPage from './pages/PageunderConstruct/PageUnderConstructionPage';

function App({ isAuthenticated, user }) {
  const addLoggingHooks = () => {
    window.onerror = (message, source, lineno, colno, error) => {
      if (error.stack) {
        const sourceFunction = error.stack.split('\n')[1];
        console.error(new Error(message + sourceFunction));
      } else {
        console.error(error);
      }
    };
    const newConsole = overrideConsole(window.console, user?.userId);
    window.console = newConsole;
  };

  useEffect(() => {
    if (isAuthenticated) {
      addLoggingHooks();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <div className="App">
      <Switch>
        <HeaderAndFooter>
          <PrivateRoute exact path="/" component={HomePage} />
          {/* File Upload page route */}
          <PrivateRoute exact path="/File-Upload-Page" component={FileUpload} />
          <PrivateRoute exact path="/File-Upload-Check-Page" component={FileUploadCheck} />
          <PrivateRoute exact path="/Template-Upload-Approve-Page" component={TemplateApprove} />
          <PrivateRoute exact path="/File-Upload-Logs" component={FileUploadLogs} />
          {/* Admin panel page route */}
          <PrivateRoute exact path="/Command-Center/Admin" component={AdminPage} />
          <PrivateRoute exact path="/Legal-Page" component={LegalPage} />
          <PrivateRoute exact path="/Legal-Page/Trademark-Registrations-Related-Matters" component={RegistrationsTreadPage} />
          <PrivateRoute exact path="/Legal-Page/Trademark-Oppositions" component={OppitionsPage} />
          <PrivateRoute exact path="/Legal-Page/Domain-Registrations-Related-Matters" component={RegistrationsPage} />
          <PrivateRoute exact path="/Legal-Page/Domain-Complaints-Disputes-Status" component={ComplaintsPage} />
          {/* Process excellenece page route */}
          <PrivateRoute exact path="/Process-Excellence" component={ProcessExcellencePage} />
          {/* Indirect Tax Page Route */}
          <PrivateRoute exact path="/Indirect-Tax" component={IndirectTaxPage} />
          <PrivateRoute exact path="/Indirect-Tax/GST-Return-Filing-Compliance-Penalties" component={GstrFilingPage} />
          <PrivateRoute exact path="/Indirect-Tax/Departmental-Notices" component={DepartmentalPage} />
          {/* Quality pages */}
          <PrivateRoute exact path="/Quality" component={QualityPage} />
          <PrivateRoute exact path="/Quality/mrc" component={MrcDeatiledPage} />
          <PrivateRoute exact path="/Quality/Quality-observation" component={QualityObservationDetailPage} />
          
          {/* Transitions page route */}
          <PrivateRoute exact path="/Transition-Page" component={TransitionPage} />
          {/* R2R Pages */}
          <PrivateRoute exact path="/Record-To-Report" component={RecordToReportPage} />
          <PrivateRoute exact path="/Record-To-Report/JLR" component={RecordToReportJLR} />
          <PrivateRoute exact path="/Record-To-Report/Agratas" component={RecordToReportAgratasPage} />
          <PrivateRoute exact path="/Record-To-Report/Bank-Reconcilation" component={RecordToReportTMLChildPage} />
          <PrivateRoute exact path="/Record-To-Report/GL-Reconciliation" component={RecordToReportTMLChildPage} />
          <PrivateRoute exact path="/Record-To-Report/InterCompany-Reconciliation" component={RecordToReportTMLChildPage} />
          <PrivateRoute exact path="/Record-To-Report/JLR/TimeLiness" component={RecordToReportJLRChildPage} />
          <PrivateRoute exact path="/Record-To-Report/JLR/Accuracy" component={RecordToReportJLRChildPage} />
          <PrivateRoute exact path="/Record-To-Report/Agratas/Bank-Reconcilation" component={RecordToReportAgratasChildPage} />
          <PrivateRoute exact path="/Record-To-Report/Agratas/TimeLiness" component={RecordToReportAgratasChildPage} />
          
          {/* P2P Pages */}
          <PrivateRoute exact path="/Procure-To-Pay" component={P2PMainPage} />

          <PrivateRoute exact path="/Procure-To-Pay/Purchase" component={PurchaseAndMDM} />
          <PrivateRoute exact path="/Procure-To-Pay/Purchase/Detail-Page" component={PurchaseAndMDM} />

          <PrivateRoute exact path="/Procure-To-Pay/MDM" component={MDMPage} />
          <PrivateRoute exact path="/Procure-To-Pay/MDM/Detail-Page" component={MDMPage} />

          <PrivateRoute exact path="/Procure-To-Pay/Account-Payable" component={AccountsPayablePage} />
          <PrivateRoute exact path="/Procure-To-Pay/Account-Payable/Detail-Page" component={AccountsPayablePage} />

          <PrivateRoute exact path="/Procure-To-Pay/CRDO" component={CRDOPage} />
          <PrivateRoute exact path="/Procure-To-Pay/CRDO/Detail-Page" component={CRDOPage} />

          <PrivateRoute exact path="/Procure-To-Pay/VMO-Contact-center" component={VMOandContactCenterPage} />
          <PrivateRoute exact path="/Procure-To-Pay/VMO-Contact-center/Detail-Page" component={VMOandContactCenterPage} />

          <PrivateRoute exact path="/Procure-To-Pay/Vendor-Payment-Scheme" component={VendorPaymentSchemePage} />
          <PrivateRoute exact path="/Procure-To-Pay/Vendor-Payment-Scheme/Detail-Page" component={VendorPaymentSchemePage} />

          <PrivateRoute exact path="/Procure-To-Pay/JLR-Main" component={JLRP2PMainPage} />
          <PrivateRoute exact path="/Procure-To-Pay/Agratas-Main" component={AgratasP2PMainPage} />

          {/* O2C Page Routes */}
          <PrivateRoute exact path="/Order-To-Cash" component={O2CMainPage} />
          <PrivateRoute exact path="/Order-To-Cash/Sales" component={O2CSalesPage} />
          <PrivateRoute exact path="/Order-To-Cash/Dispatch-and-Billing" component={O2CDispatchAndBillingPage} />
          <PrivateRoute exact path="/Order-To-Cash/After-Sales" component={O2CAfterSalesPage} />
          {/* H2R Page Routes */}
          {/* <PrivateRoute exact path="/Hire-To-Retire" component={HireToRetireMainPage} />
          <PrivateRoute exact path="/Hire-To-Retire/Payroll-Compliance" component={PayrollAndCompliancePage} />
          <PrivateRoute exact path="/Hire-To-Retire/Time-Office-Retrials" component={TimeOfficeRetrialsPage} />
          <PrivateRoute exact path="/Hire-To-Retire/Benefit-Administration" component={BenefitsAdministrationPage} />
          <PrivateRoute exact path="/Hire-To-Retire/Recuritment" component={RecuritmentPage} /> */}
          {/* Finance Page Routes */}
          <PrivateRoute exact path="/Finance-Page" component={FinancePage} />
          <PrivateRoute exact path="/Finance-Page/Revenue-Business" component={RevenueBusinessPage} />
          <PrivateRoute exact path="/Finance-Page/Total-Contract-Value-DSO" component={ContractDsoPage} />
          <PrivateRoute exact path="/Finance-Page/Finance-Cost" component={FinanceCostPage} />
          <PrivateRoute exact path="/Finance-Page/Margin-TMGSL" component={MarginTmgslPage} />
          <PrivateRoute exact path="/Finance-Page/Margin-Gdc-Distribution" component={GdcDistPage} />
          {/* Direct Tax pages */}
          {/* <PrivateRoute exact path="/Direct-Tax" component={DirectTaxPage} />
          <PrivateRoute exact path="/Direct-Tax/TDSReturns" component={TDSReturns} />
          <PrivateRoute exact path="/Direct-Tax/AdvanceTax" component={AnnualTaxPage} />
          <PrivateRoute exact path="/Direct-Tax/Departmental-Notice" component={DepartmentalNotice} />
          <PrivateRoute exact path="/Direct-Tax/AnnualTaxFilling" component={AnnualTaxFilingsPage} /> */}
          {/* HSN Report */}
          <PrivateRoute exact path="/HSN-Report-1" component={HSNDetailReportPageComp} />
          <PrivateRoute exact path="/HSN-Report-2" component={HSNGSTRatewiseReport} />
          {/* P2P GL Reconciliation */}
          {/* <PrivateRoute exact path="/GL-Reconciliation" component={GLReconPage} /> */}
          <PrivateRoute exact path="/Procure-To-Pay/Account-Payable/GL-Reconciliation" component={GLReconPage} />
          {/* <PrivateRoute exact path="/GL-Reconciliation-Detail" component={GLReconPageDetail} /> */}
          <PrivateRoute exact path="/Page-under-construtuion" component={PageUnderConstructionPage} />
          {/* Retention GL Pages */}
          <PrivateRoute exact path="/Procure-To-Pay/Account-Payable/Retention-GL-Reconciliation" component={GLRetantionPage} />
        </HeaderAndFooter>
      </Switch>
    </div>
  );
}

App.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  user: PropTypes.object,
};

export default connect(({ auth }) => ({
  isAuthenticated: auth.isAuthenticated,
  user: auth.user,
}))(App);
